import React, {FC, MutableRefObject} from "react";
import {useTranslation} from "react-i18next";
import {Accessibility} from "../../../models/Accessibility";
import {AccessibilityUnit} from "../../../models/AccessibilityUnits";
import MixpanelTrackingList from "./MixpanelTrackingList";
import ContentBlock from "./ContentBlock";
import AccessibilityList from "./AccessibilityList";
import SkeletonList from "../../../components/SkeletonList";

type PropsType = {
  arrayOfPropertyItemAccessibilityUnits: AccessibilityUnit[]
  itemAccessibilities: Accessibility[]
  locatedOn?: {
    type: string
    triggeredOnPage: string,
    section: string
  }
  refs: MutableRefObject<HTMLDivElement[] | null[]>
}

const GeneralItemInfoContainer: FC<PropsType> = ({
  arrayOfPropertyItemAccessibilityUnits,
  itemAccessibilities,
  locatedOn,
  refs,
}) => {
  const {t} = useTranslation()

  return (
    <ContentBlock label={t("mainContainer_generalInformation")}>
      <MixpanelTrackingList locatedOn={locatedOn}>
        {arrayOfPropertyItemAccessibilityUnits && arrayOfPropertyItemAccessibilityUnits.length > 0 ? (
          <AccessibilityList
            accessibilityUnits={arrayOfPropertyItemAccessibilityUnits}
            accessibilities={itemAccessibilities}
            refs={refs}
          />
        ) : (
          <SkeletonList/>
        )}
      </MixpanelTrackingList>
    </ContentBlock>
  )
}

export default GeneralItemInfoContainer
